<template>
    <div class="pro_index">
        <el-container>
            <el-aside style="width: 200px">
                <ul class="left_url_tab">
                    <li class="li-title_1">仓库管理</li>
                    <el-row>
                        <el-col :span="18">
                            <li class="li-title_2 title-2-select" @click="title2Click($event,'/repository/manage/goodsManage')">
                                商品管理
                            </li>
                        </el-col>
                        <el-col :span="6">
                            <li class="li-title_2_1" style="list-style: none" href="javascript:void(0)" @click="setClassManage">
                                <el-link style="margin-left: -7px" type="primary">设置</el-link>
                            </li>
                        </el-col>
                    </el-row>
                    <li class="li-title_2" @click="title2Click($event,'/repository/manage/repositoryCheckList')">仓库清单</li>
                    <li class="li-title_2" @click="title2Click($event,'/repository/manage/goodsPair')">商品配对</li>
                </ul>
                <ul class="left_url_tab">
                    <li class="li-title_1">仓库配置</li>
                    <li class="li-title_2" @click="title2Click($event,'/repository/setup/setup')">
                        仓库设置
                    </li>
                </ul>
            </el-aside>
            <el-main>
                <router-view>

                </router-view>
            </el-main>
        </el-container>
        <ClassManage @closeCMDialog_z="closeCMDialog_f" :classManageDialog="classManageDialog" ></ClassManage>
    </div>
</template>

<script>
    import ClassManage from '@/components/product/ClassManage'
    import {loadDataMap} from '@/api/tree/tree'
    import {getAllStore} from '@/api/store/storeSet'
    export default {
        name: "index",
        components:{
            ClassManage
        },
        data() {
            return {
                classManageDialog:false,//管理分类弹窗默认关闭

            }
        },
        created() {
            loadDataMap().then((res) => {
                let data = this.optionData(res.data);
                this.$store.commit('setTreeSelectData',data)
            });
            getAllStore().then(res =>{
                if(res.code == 200){
                    let arr = [];
                    res.rows.forEach(row =>{
                        arr.push({label:row.wareName,value:row.wareId})
                    });
                    this.$store.commit('setRepositoryList',arr)
                }else{
                    console.log('获取仓库数据异常~~');
                }
            }).catch(err =>{});
        },
        methods: {
            title2Click(e,url){
                var _dom = document.querySelector('.li-title_2.title-2-select');
                if (_dom) {
                    _dom.classList.toggle('title-2-select');//当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
                }
                e.target.classList.toggle('title-2-select');
                this.$router.push(url);
            },
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId == 0;      //返回第一层
                });
            },
        },
        mounted() {}
    }
</script>

<style scoped>
    /*@import '../../assets/css/product.css';*/
    @import '../../assets/css/repository.css';
    .pro_index{
        width: 100%;
    }
    .left_url_tab{
        border: 1px solid #ccc;
        border-bottom: none;
        font-size: 13px;
    }
    .left_url_tab li:not(:last-child){
        list-style: none;

    }

    .li-title_1{
        height: 32px;
        line-height: 32px;
        background-color: #c1c1c154;
        vertical-align: top;
        padding-left: 5px;
        font-weight: 600;
    }
    .li-title_2{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 20px;
        border-bottom: 1px solid #ccc;
    }
    .li-title_2_1{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 20px;
        border-bottom: 1px solid #ccc;
    }
    .li-title_3{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        padding-left: 40px;
    }
    .li-title_2:not(.tree-item):hover{
        background-color: #409eff;
        color: white;
        cursor: pointer;
    }
    .title-2-select{
        background-color: #409eff;
        color: white;
        cursor: pointer;
    }
    .li-help{
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        text-align: center;
        font-size: 16px;
    }
    .li-help a{
        text-decoration: none;
        color: #409eff;
    }
    .tree-item{
        height: auto !important;
        padding: initial;
    }
    .tree-item .el-tree{background: initial !important;}
    .tree-item .el-tree:hover{background: initial !important;}

</style>
